export default {
  text: 'Bestelle direkt auf unserer Seite für schnellen Service, um gratis Essen zu verdienen, und hilf uns Lieferplattform-Provisionen zu sparen',
  text_delivery: '<strong>Lieferung & Abholung:</strong> Bestelle direkt auf unserer Seite für schnellen Service, um gratis Essen zu verdienen, und hilf uns Lieferplattform-Provisionen zu sparen',
};